/**
 * שגיאת API ציבורי משותפת — קטלוג (4.2) והצעות מחיר (4.3/5.2).
 * ⭐ הוצא מ-`catalogApi.ts` כשנוסף `quotesApi.ts`, כדי ששתי חתיכות ה-API
 * הציבורי ישתפו טיפול שגיאות זהה במקום שני מימושים כמעט-זהים.
 */

export class PublicApiError extends Error {
  status: number;
  code: string;

  constructor(status: number, code: string, message: string) {
    super(message);
    this.status = status;
    this.code = code;
  }
}

export function isPublicApiError(error: unknown): error is PublicApiError {
  return error instanceof PublicApiError;
}

export async function parseErrorBody(res: Response): Promise<PublicApiError> {
  try {
    const body = (await res.json()) as { error?: { code?: string; message?: string } };
    return new PublicApiError(
      res.status,
      body.error?.code ?? 'UNKNOWN_ERROR',
      body.error?.message ?? 'אירעה שגיאה לא צפויה.',
    );
  } catch {
    return new PublicApiError(res.status, 'UNKNOWN_ERROR', 'אירעה שגיאה לא צפויה.');
  }
}
